module.exports = __webpack_public_path__ + "static/img/ENessential1.b72f9fe4.png";